module.exports = __webpack_public_path__ + "img/img_30.b2ea3924.png";